import { Box, Dialog, DialogContent, DialogTitle, LinearProgress, Typography } from '@mui/material';

/**
 * Progresso determinado (0–100%) do salvamento do checklist — mesmo padrão do
 * "Imprimindo Comprovante" de `Sale.js` (Dialog + LinearProgress determinate),
 * com a porcentagem numérica. Não fecha por clique fora/ESC: bloqueia a
 * interação até quem usa baixar `open`.
 */
export default function SaveProgressDialog({ open, progress = 0, title = 'Salvando checklist' }) {
    const value = Math.max(0, Math.min(100, Math.round(progress)));
    return (
        <Dialog
            open={!!open}
            disableEscapeKeyDown
            maxWidth="xs"
            fullWidth
            sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
            PaperProps={{ sx: { borderRadius: '20px' } }}
        >
            <DialogTitle sx={{ fontSize: '16px', fontWeight: 800 }}>{title}</DialogTitle>
            <DialogContent>
                <Box sx={{ width: '100%', mt: 1, mb: 1 }}>
                    <LinearProgress
                        variant="determinate"
                        value={value}
                        sx={{
                            height: 10,
                            borderRadius: 5,
                            '& .MuiLinearProgress-bar': { borderRadius: 5, backgroundImage: (t) => t.palette.gradient.brand },
                        }}
                    />
                </Box>
                <Typography sx={{ fontSize: '13px', fontWeight: 700, textAlign: 'right' }}>{value}%</Typography>
            </DialogContent>
        </Dialog>
    );
}
